import React, { useEffect, useRef, useState } from "react"
import { getShortenedUrl, sanitizeInnerHtml } from "@/utils/helper"
import { datalayerForLinkEvent } from "@/components/Default/Text/v1/analytics/index"

const Text = props => {
  const [dataVal, setDataVal] = useState("")
  const linkTextRef = useRef()
  const {
    data: { text = "", appliedCssClassNames = "", richText = false } = {},
  } = props
  const removeHtmlExtension = async () => {
    const newData = await getShortenedUrl(text)
    setDataVal(newData)
  }
  useEffect(() => {
    if (richText) {
      removeHtmlExtension()
    }
  }, [richText])

  useEffect(() => {
    if (linkTextRef?.current) {
      linkTextRef?.current?.querySelectorAll("a").forEach(item => {
        item?.addEventListener("click", e => {
          datalayerForLinkEvent(e)
        })
      })
      return () => {
        linkTextRef?.current?.querySelectorAll("a").forEach(item => {
          item?.removeEventListener("click", e => {
            datalayerForLinkEvent(e)
          })
        })
      }
    }
  }, [dataVal, text])

  return (
    <div
      className={`text ${appliedCssClassNames ? appliedCssClassNames : ""}`}
      ref={linkTextRef}
    >
      {richText ? (
        <div className="cmp-text">{sanitizeInnerHtml(dataVal)}</div>
      ) : (
        <div className="cmp-text">
          <p className="cmp-text__paragraph" aria-label={text}>
            {text}
          </p>
        </div>
      )}
    </div>
  )
}

export default Text
